import Vue from 'vue'
import VueRouter from 'vue-router'
import routers from './routers.js'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)
const NotFoundComponent = { template: '<div>NotFoundComponent</div>' }

export default new VueRouter({
  mode: 'history', // 'hash' | 'history' | 'abstract'
  routes: [
    { path: '/login', component: routers.Login },
    // { path: '/collectionlogin', component: routers.collectionlogin },
    {
      path: '/',
      component: routers.Layout,
      redirect: '/login',
      children: [
        // { path: '/traderinfo', component: routers.traderinfo, meta: { title: '操盘手管理' } },
        { path: '/traderinfo', component: routers.trader_tradermanage, meta: { title: '操盘手管理' } },
        // { path: '/merchantinfo', component: routers.merchantinfo, meta: { title: '商户管理' } },
        { path: '/merchantinfo', component: routers.trader_merchantmanage, meta: { title: '商户管理' } },
        // { path: '/hallinfo', component: routers.hallinfo, meta: { title: '营业厅管理' } },
        { path: '/hallinfo', component: routers.trader_hallmanage, meta: { title: '营业厅管理' } },
        // //订单管理
        // { path: '/orderList', component: routers.orderList, meta: { title: '订单管理' } },
        { path: '/orderList', component: routers.trader_ordermanage, meta: { title: '订单管理' } },
        { path: '/orderListdetail', component: routers.orderListdetail, meta: { title: '订单详情' } },
        { path: '/settlementlist', component: routers.settlementlist, meta: { title: '结算列表' } },
        { path: '/settlementlistdetail', component: routers.settlementlistdetail, meta: { title: '结算详情' } },
        { path: '/settlementorder', component: routers.settlementorder, meta: { title: '结算订单' } },
        // { path: '/settlementorderdetail', component: routers.settlementorderdetail,meta: { title: '结算订单详情' }},

        // //商户订单管理
        { path: '/merchantorderList', component: routers.merchantorderList, meta: { title: '订单管理' } },
        // { path: '/orderListdetail', component: routers.orderListdetail,meta: { title: '订单详情' }},
        { path: '/merchantsettlementlist', component: routers.merchantsettlementlist, meta: { title: '结算列表' } },
        { path: '/marchantorderListdetail', component: routers.marchantorderListdetail, meta: { title: '结算详情' } },
        // { path: '/settlementorder', component: routers.settlementorder,meta: { title: '结算订单' }},
        // 更改密码
        { path: '/updatapass', component: routers.updataPass, meta: { title: '更改密码' } }
      ]
    },
    {
      path: "/404",
      name: "notFound",
      component: routers.NotFound
    },
    { path: '*', component: routers.NotFound }
  ]
})
